module.exports = __webpack_public_path__ + "fa-brands-400.ba7ed552362f64d30f6d.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/webfonts/fa-brands-400.svg
// module id = ../../../../../src/assets/fonts/webfonts/fa-brands-400.svg
// module chunks = styles